import React from 'react';
import {
  DividerLine,
  PaymentOptionButton,
  SectionContainerWrapper,
  SectionTitle,
  TitleBorderWrapper
} from '../../styled';
import PaymentSchemeTable from './PaymentSchemeTable';
import Icons from '../../../../components/icons';
import AddNewPaymentOptionForm from './AddNewPaymentOption';
import ClonePaymentOptionForm from './ClonePaymentOptionForm';
import PaymentSchemeDetail from '../installment/PaymentSchemeDetail';
import { useFeeStructureContext } from '../../context/FeeStructureContext';

const PaymentOptionSection = () => {
  const {
    paymentOptionData,
    isPaymentOptionModalOpen,
    isPaymentSchemeDetail,
    handlePaymentSchemeDetailClose,
    handlePaymentSchemeClone,
    handleAddPaymentScheme,
    setIsPaymentOptionModalOpen
  } = useFeeStructureContext();

  const handlePaymentOptionClose = () => {
    setIsPaymentOptionModalOpen(null);
  };

  return (
    <SectionContainerWrapper>
      <TitleBorderWrapper>
        <SectionTitle>Payment Options</SectionTitle>
        <DividerLine />
        <PaymentOptionButton
          onClick={() => setIsPaymentOptionModalOpen('newPayment')}
        >
          <Icons.PlusWhite style={{ marginRight: '6px' }} /> Add New Payment
          Option
        </PaymentOptionButton>
        <PaymentOptionButton
          onClick={() => setIsPaymentOptionModalOpen('clonePayment')}
          disabled={paymentOptionData && paymentOptionData.length !== 0}
        >
          <Icons.PlusWhite style={{ marginRight: '6px' }} /> Clone Payment
          Option
        </PaymentOptionButton>
      </TitleBorderWrapper>
      {paymentOptionData && <PaymentSchemeTable />}
      <AddNewPaymentOptionForm
        open={isPaymentOptionModalOpen === 'newPayment'}
        onClose={handlePaymentOptionClose}
        handleAddPaymentScheme={handleAddPaymentScheme}
      />
      {isPaymentOptionModalOpen === 'clonePayment' && (
        <ClonePaymentOptionForm
          open={isPaymentOptionModalOpen === 'clonePayment'}
          onClose={handlePaymentOptionClose}
          handlePaymentSchemeClone={handlePaymentSchemeClone}
        />
      )}
      <PaymentSchemeDetail
        isPaymentSchemeDetail={isPaymentSchemeDetail}
        onClose={handlePaymentSchemeDetailClose}
      />
    </SectionContainerWrapper>
  );
};

export default PaymentOptionSection;
